// src/components/ProjectsPage.js (Formerly project.js)

import React, { useState, useEffect, useRef } from "react";
import ProjectCard from "./ProjectCard"; // <-- Import the new ProjectCard
import logoSrc from "../img/logo.png";
import ContactForm from "../ContactForm";
import "./About.css";

const ProjectsPage = () => {
  const contactFormRef = useRef();

  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm();
    }
  };

  const [projects, setProjects] = useState([]); // Changed name to projects
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    // MODIFIED: Fetch from your new API endpoint for projects
    fetch("https://apiqms.shigjeta.com/api/projects")
      .then((response) => response.json())
      .then((data) => {
        setProjects(data);
      })
      .catch((error) => {
        console.error("Error loading project data:", error);
      });
  }, []);

  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <>
      {/* ... Hero and other sections are fine, just change text if needed ... */}
      <section className="shop-products" id="projects">
        <div className="shop-header">
          <h1>Our Exclusive Projects</h1>
          <p>Browse through our portfolio of completed and ongoing projects.</p>
        </div>

        {/* ... Category filter is fine, just update categories ... */}

        {/* Product List Section */}
        <div className="shop-product-list">
          {filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              // Use the new ProjectCard, passing the project data
              <ProjectCard key={project.id} project={project} />
            ))
          ) : (
            <p>No projects found in this category.</p>
          )}
        </div>
      </section>

      {/* <-- The Modal for detailed view has been REMOVED --> */}

      {/* ... CTA section is fine ... */}
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default ProjectsPage;
